import { connectorsForWallets } from '@rainbow-me/rainbowkit'
import { injectedWallet, metaMaskWallet, rabbyWallet, walletConnectWallet } from '@rainbow-me/rainbowkit/wallets'
import { createConfig, http } from 'wagmi'
import { config, flare } from './config'

/**
 * Wallet connection: wagmi + RainbowKit.
 *
 * RainbowKit is the thin choice here rather than the feature-rich one. `router-stack`
 * already standardises on viem, wagmi is viem's React layer, and RainbowKit is a connector
 * list and a modal over wagmi — it adds no signing path of its own, no hosted service and
 * no account abstraction. Rabby, MetaMask and WalletConnect are three entries in the list
 * below, not three integrations.
 *
 * WalletConnect needs a project id (free, cloud.reown.com). Without one the entry is left
 * out rather than shown and made to fail on click, and `walletConnectAvailable` lets the UI
 * say why.
 */

export const walletConnectAvailable = config.walletConnectProjectId.length > 0

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [rabbyWallet, metaMaskWallet, ...(walletConnectAvailable ? [walletConnectWallet] : []), injectedWallet],
    },
  ],
  {
    appName: 'SparkDEX Swap',
    // Unused when no WalletConnect-backed entry is in the list above; the option is required.
    projectId: config.walletConnectProjectId || 'sparkdex-local',
  }
)

export const wagmiConfig = createConfig({
  chains: [flare],
  connectors,
  transports: { [flare.id]: http(flare.rpcUrls.default.http[0]) },
  // Batch the balance/allowance reads this app makes through Multicall3, the same way the
  // rest of the stack does. Note this is wagmi's *contract* multicall, not viem's JSON-RPC
  // request batching, which WP4 measured Flare rejecting outright (-32602 on an oversized
  // batch, silently surfacing as "no liquidity"). Request batching stays off.
  batch: { multicall: true },
  ssr: false,
})

declare module 'wagmi' {
  interface Register {
    config: typeof wagmiConfig
  }
}
